import { t } from '@lingui/macro'
import { useTheme } from 'styled-components'

import { Span } from '@/@bothrs-ui/web/components/typography/Body'
import { useServer } from '@/modules/healthblocks/ServerProvider'
import { StyledContainer, StyledLogo, StyledTextContainer } from './HospitalIndicator.styled'

import type { FC } from 'react'

interface HospitalIndicatorProps {
  className?: string
  variant?: 'sidebar' | 'card' | 'profile-card' | 'header'
}

export const HospitalIndicator: FC<HospitalIndicatorProps> = ({ className, variant = 'card' }) => {
  const server = useServer()
  const theme = useTheme()

  if (!server) return null

  return (
    <StyledContainer className={className} variant={variant}>
      {server.logo && variant !== 'header' && variant !== 'sidebar' && (
        <StyledLogo src={server.logo} alt={server.display} variant={variant} />
      )}
      <StyledTextContainer variant={variant}>
        {variant === 'header' ? (
          <Span
            type='BodySmallRegular'
            style={{
              color: theme.Colors.Neutrals.Darkest,
              opacity: 0.8,
              maxWidth: '80%',
            }}
          >
            {t({
              id: 'hospital-indicator.logged-in-at',
              message: 'Ingelogd bij',
            })}{' '}
            <span style={{ fontWeight: 700 }}>{server.display}</span>
          </Span>
        ) : (
          <>
            <Span
              type='BodySmallRegular'
              style={{
                color: theme.Components.Navigation.Text,
                marginBottom: 2,
                opacity: variant === 'sidebar' ? 1 : 0.8,
              }}
            >
              {t({
                id: 'hospital-indicator.logged-in-at',
                message: 'Ingelogd bij',
              })}
            </Span>
            <Span
              type={
                variant === 'card' ? 'BodySmallBold' : variant === 'profile-card' ? 'BodySmallBold' : 'BodySmallRegular'
              }
              style={{
                color:
                  variant === 'sidebar' || variant === 'profile-card'
                    ? theme.Colors.Neutrals.Darkest
                    : theme.Components.Card.Text,
                // Handle long hospital names
                whiteSpace: 'normal',
                lineHeight: '1.2',
              }}
            >
              {server.display}
            </Span>
          </>
        )}
      </StyledTextContainer>
    </StyledContainer>
  )
}
